//@mutations
export const mutations = {
  mutate(state: any, data: { key: string; value: any }) {
    state[data.key] = data.value;
  },
  updateResource(state: any, resource: any) {
    state.resource = resource;
  },
  updateResourceId(state: any, resource_id: any) {
    state.resource_id = resource_id;
  },
};
